const whitelist = ["/fresh/ai/predict", "banners"]
export const validate = function (url) {
  if(url.includes(".com")) {
    url = url.split(".com")[1]
    return whitelist.includes(url)
  } else {
    return whitelist.includes(url)
  }
}
export default whitelist
